export default "__VITE_ASSET__50CNnyfT__"